export const getDeclarationStatus = (status): string => {
  if (status === "created") return "Создано";
  if (status === "moderated") return "Прошло модерацию";
  if (status === "inwork") return "В работе";
  if (status === "finished") return "Завершено";
  if (status === "rejected") return "Отклонено";
  return status;
};
